module.exports = __webpack_public_path__ + "assets/img/go.b763ca14.png";